(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["db-cart"] && !Shopify.designMode) return;
  try {
    (()=>{
 const root=document.querySelector('[data-db-cart]');if(!root||root.dataset.ready)return;root.dataset.ready='true';
 const panel=root.querySelector('.db-cart-panel'),toggle=root.querySelector('.db-cart-toggle'),list=root.querySelector('[data-cart-items]'),status=root.querySelector('[data-cart-status]'),checkout=root.querySelector('[name="checkout"]');let busy=false,opener=toggle;
 const money=(n,c)=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:c}).format(n/100);
 function open(source=toggle){opener=source;panel.hidden=false;toggle.setAttribute('aria-expanded','true');root.querySelector('[data-cart-arrow]').textContent='↓';root.querySelector('[data-cart-close]').focus();}
 function close(){panel.hidden=true;toggle.setAttribute('aria-expanded','false');root.querySelector('[data-cart-arrow]').textContent='↑';opener?.focus();}
 function node(tag,text,cls){const el=document.createElement(tag);if(text!==undefined)el.textContent=text;if(cls)el.className=cls;return el;}
 function render(cart){list.replaceChildren();root.querySelector('[data-cart-count]').textContent=cart.item_count;root.querySelector('[data-cart-total]').textContent=money(cart.total_price,cart.currency);checkout.disabled=!cart.item_count;status.textContent=cart.item_count?'':root.dataset.empty;
 cart.items.forEach(item=>{const row=node('article',undefined,'db-cart-item');if(item.image){const image=node('img');const imageUrl=new URL(item.image,location.origin);const path=imageUrl.pathname.match(/\/s\/files\/\d+\/\d+\/\d+\/\d+\/(.*)/);if(path){imageUrl.host=location.host;imageUrl.pathname='/cdn/shop/'+path[1];}imageUrl.searchParams.set('width','180');image.src=imageUrl.href;image.alt=item.product_title;row.append(image);}else row.append(node('span'));
 const info=node('div'),link=node('a',item.product_title);link.href=item.url;info.append(link);if(item.variant_title)info.append(node('p',item.variant_title));if(item.selling_plan_allocation)info.append(node('p',item.selling_plan_allocation.selling_plan.name));Object.entries(item.properties||{}).filter(([k,v])=>!k.startsWith('_')&&v).forEach(([k,v])=>info.append(node('p',k+': '+v)));info.append(node('p',money(item.final_line_price,cart.currency)));
 const controls=node('div');[-1,1].forEach(delta=>{const b=node('button',delta===-1?'−':'+');b.type='button';b.setAttribute('aria-label',root.dataset.quantity+' '+(item.quantity+delta)+': '+item.product_title);b.addEventListener('click',()=>change(item.key,item.quantity+delta));if(delta===1)controls.append(node('span',String(item.quantity)+' '));controls.append(b);});const remove=node('button',root.dataset.remove,'db-cart-remove');remove.type='button';remove.addEventListener('click',()=>change(item.key,0));controls.append(remove);info.append(controls);row.append(info);list.append(row);});
 document.querySelectorAll('.dbc-header a,.dbp-header a').forEach(a=>{if(new URL(a.href).pathname===root.dataset.url)a.textContent=root.querySelector('.db-cart-toggle>span').textContent;});}
 async function read(){const response=await fetch(root.dataset.url+'.js',{headers:{Accept:'application/json'},cache:'no-store'});if(!response.ok)throw Error(root.dataset.error);render(await response.json());}
 function lock(value){busy=value;root.querySelectorAll('.db-cart-items button,.db-cart-checkout').forEach(b=>b.disabled=value);}
 async function change(id,quantity){if(busy)return;lock(true);try{const r=await fetch(root.dataset.change+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id,quantity})});const data=await r.json();if(!r.ok)throw Error(data.description||root.dataset.error);render(data);}catch(e){status.textContent=e.message;}finally{busy=false;list.querySelectorAll('button').forEach(b=>b.disabled=false);checkout.disabled=list.children.length===0;}}
 toggle.addEventListener('click',()=>{if(!panel.hidden){close();return;}open();read().catch(()=>{status.textContent=root.dataset.error;checkout.disabled=true;});});root.querySelector('[data-cart-close]').addEventListener('click',close);root.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();close();}});
 document.addEventListener('click',e=>{const a=e.target.closest('.dbc-header a,.dbp-header a');if(a&&new URL(a.href).pathname===root.dataset.url){e.preventDefault();open(a);read().catch(()=>status.textContent=root.dataset.error);}});
 document.addEventListener('submit',async e=>{const form=e.target;if(!form.querySelector('[data-db-options]')||e.defaultPrevented)return;e.preventDefault();if(busy)return;const id=form.querySelector('[data-variant-id]');if(!id||id.disabled||!id.value)return;busy=true;const button=form.querySelector('button[type="submit"]');button.disabled=true;try{const data=new FormData(form);data.delete('return_to');const r=await fetch(root.dataset.add+'.js',{method:'POST',headers:{Accept:'application/json'},body:data});const result=await r.json();if(!r.ok)throw Error(result.description||root.dataset.error);await read();open(button);}catch(error){open(button);status.textContent=error.message;}finally{busy=false;button.disabled=false;}});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["db-delivery-returns"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(scope) {
    scope.querySelectorAll('[data-db-policy]').forEach(root => {
      if(root.dataset.ready) return;
      root.dataset.ready='true';
      const trigger=root.querySelector('[data-policy-open]');
      const dialog=root.querySelector('dialog');
      if(!dialog || typeof dialog.showModal!=='function') return;
      trigger.addEventListener('click',event => { event.preventDefault(); dialog.showModal(); });
      root.querySelector('[data-policy-close]').addEventListener('click',() => dialog.close());
      dialog.addEventListener('click',event => {
        const rect=dialog.getBoundingClientRect();
        if(event.target===dialog && (event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom)) dialog.close();
      });
      dialog.addEventListener('close',() => trigger.focus());
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["db-market-change"] && !Shopify.designMode) return;
  try {
    class DBMarketChange extends HTMLElement {
    connectedCallback() {
      this.container = this.closest('[data-db-product], [data-product]');
      this.onVariant = event => this.updateVariant(event.detail.variant);
      this.container?.addEventListener('db:variant', this.onVariant);
      const picker=this.container?.querySelector('[data-db-options]');
      if(picker) {
        try {
          const variants=JSON.parse(picker.querySelector('[data-variants]').textContent);
          const id=picker.querySelector('[data-variant-id]').value;
          const variant=variants.find(v=>v.id===id);
          if(variant)this.updateVariant(variant);
        } catch { this.hidden=true; }
      }
    }
    disconnectedCallback() {this.container?.removeEventListener('db:variant',this.onVariant);}
    updateVariant(variant) {
      this.dataset.variantId=variant.id;
      this.dataset.currentPrice=variant.priceCents;
      let market;
      try {market=JSON.parse(this.dataset.market);} catch {this.hidden=true;return;}
      const base=market?.bases?.[variant.id], current=variant.priceCents;
      const previous=current-market?.delta;
      this.hidden=!(market?.version===1 && market.currency===this.dataset.currency && Number.isSafeInteger(base) && base+market.offset===current && previous>0);
      if(this.hidden)return;
      const delta=market.delta;
      const money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:market.currency}).format(Math.abs(delta)/100);
      this.querySelector('.db-market-change__amount').textContent=`${delta>0?'↑ +':delta<0?'↓ −':'— '}${money}`;
      this.querySelector('.db-market-change__percent').textContent=`${delta>0?'+':''}${(delta/previous*100).toFixed(2)}%`;
    }
  }
  if(!customElements.get('db-market-change'))customElements.define('db-market-change',DBMarketChange);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["db-market-history"] && !Shopify.designMode) return;
  try {
    class DBMarketHistory extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.closest('.shopify-section') || this, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-id','data-current-price']});
      this.refresh();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    refresh() {
      const section = this.closest('.shopify-section');
      const price = section?.querySelector(`.db-market-change[data-product-id="${this.dataset.productId}"]`);
      const variant = price?.dataset.variantId || this.dataset.variantId;
      const signature = variant + ':' + price?.dataset.currentPrice;
      if (this.signature === signature) return;
      this.signature = signature;
      let market;
      try { market = JSON.parse(this.dataset.market); } catch { return; }
      const base = market?.bases?.[variant];
      let archives=[];
      try { archives=JSON.parse(this.querySelector('[data-market-archives]').textContent); } catch {}
      const recorded=new Map();
      for(const entry of archives.filter(Boolean)) {
        if(entry.currency!==market?.currency || entry.bases?.[variant]!==base)continue;
        for(const p of entry.points||[])recorded.set(p[0],p);
      }
      for(const p of market?.points||[])recorded.set(p[0],p);
      const points=[...recorded.values()].sort((a,b)=>a[0]-b[0]);
      const valid = market?.version === 1 && market.currency === this.dataset.currency && Number.isSafeInteger(base) && Array.isArray(points) && points.length > 0 && base + market.offset === Number(price?.dataset.currentPrice);
      this.querySelector('[data-market-empty]').hidden = valid;
      this.querySelector('[data-market-records]').hidden = !valid;
      if (!valid) return;
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:market.currency}).format(cents / 100);
      const time = hour => new Date(hour * 3600000).toLocaleString(undefined, {dateStyle:'medium', timeStyle:'short'});
      const visible = points.slice(-720);
      const low = Math.min(...visible.map(p=>base+p[1])), high = Math.max(...visible.map(p=>base+p[1]));
      this.querySelector('[data-market-range]').textContent = `${time(visible[0][0])} — ${time(visible.at(-1)[0])} · ${money(low)} — ${money(high)}`;
      const firstHour = visible[0][0], lastHour = visible.at(-1)[0];
      this.querySelector('polyline').setAttribute('points', visible.map(p=>`${12+(p[0]-firstHour)/Math.max(1,lastHour-firstHour)*576},${high===low?90:168-(base+p[1]-low)/(high-low)*156}`).join(' '));
      const rows = document.createDocumentFragment();
      visible.forEach((p,i)=>{
        const tr=document.createElement('tr');
        const delta=i ? p[1]-visible[i-1][1] : null;
        const prev=i ? base+visible[i-1][1] : 0;
        const change=delta===null?'—':`${delta>0?'↑ +':delta<0?'↓ −':'— '}${money(Math.abs(delta))}${prev>0?` (${delta>0?'+':''}${(delta/prev*100).toFixed(2)}%)`:''}`;
        for(const value of [time(p[0]),money(base+p[1]),change]) {const td=document.createElement('td');td.textContent=value;tr.append(td);}
        rows.prepend(tr);
      });
      this.querySelector('tbody').replaceChildren(rows);
    }
  }
  if (!customElements.get('db-market-history')) customElements.define('db-market-history', DBMarketHistory);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["db-product-options"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(scope){
    scope.querySelectorAll('[data-db-options]').forEach(picker=>{
      if(picker.dataset.ready)return;
      picker.dataset.ready='true';
      const form=picker.closest('form');
      const fields=[...picker.querySelectorAll('[data-option-position]')];
      const variants=JSON.parse(picker.querySelector('[data-variants]').textContent);
      const id=picker.querySelector('[data-variant-id]');
      const submit=form.querySelector('button[type="submit"]');
      const status=picker.querySelector('[data-option-status]');
      const container=picker.closest('[data-db-product]')||picker.closest('[data-product]');
      function update(announce){
        const values=fields.map(f=>f.value);
        const complete=values.every(Boolean);
        const variant=complete?variants.find(v=>fields.length===0||v.options.every((o,i)=>o===values[i])):null;
        id.value=variant?.id||'';id.disabled=!variant?.available;submit.disabled=!variant?.available;
        submit.textContent=variant&&!variant.available?picker.dataset.sold:picker.dataset.add;
        status.textContent=complete&&!variant?picker.dataset.unavailable:complete&&variant&&!variant.available?picker.dataset.sold:announce&&!complete?picker.dataset.choose:'';
        if(announce){
          const colorField=fields.find(f=>f.hasAttribute('data-color-option'));
          const colorIndex=colorField?Number(colorField.dataset.optionPosition):-1;
          const color=colorField?.value;
          const imageVariant=variant?.image?variant:color?variants.find(v=>v.options[colorIndex]===color&&v.image):null;
          if(imageVariant){
            const image=container?.querySelector('.dbc-product-image');
            if(image){image.removeAttribute('srcset');image.src=imageVariant.image;}
            const media=[...container.querySelectorAll('[data-media]')];
            if(media.some(m=>m.dataset.media===imageVariant.media)){
              media.forEach(m=>{m.hidden=m.dataset.media!==imageVariant.media;if(m.hidden)m.querySelectorAll('video').forEach(v=>v.pause());});
              container.querySelectorAll('[data-thumbnail]').forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.thumbnail===imageVariant.media)));
            }
          }
          if(color){const label=container?.querySelector('[data-product-color]');if(label)label.textContent=color;}
        }
        if(variant){
          const price=container?.querySelector('[data-db-price]');if(price)price.textContent=variant.price;
          if(announce)picker.dispatchEvent(new CustomEvent('db:variant',{bubbles:true,detail:{variant,options:values}}));
        }
      }
      fields.forEach(field=>field.addEventListener('change',()=>update(true)));
      form.addEventListener('submit',e=>{update(true);if(id.disabled){e.preventDefault();fields.find(f=>!f.value)?.focus();}});
      update(false);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["db-site-music"] && !Shopify.designMode) return;
  try {
    (() => {
  const host = document.getElementById('db-site-music');
  if (!host || host.dataset.ready) return;
  host.dataset.ready = 'true';
  const audio = host.querySelector('audio');
  const button = host.querySelector('button');
  const positionKey = 'db-all-the-love-position';
  let enabled = true, pending = false, savedPosition = 0, lastSaved = 0;
  const competing = new Set();
  try {
    enabled = localStorage.getItem('db-music-enabled') !== 'off';
    savedPosition = Number(sessionStorage.getItem(positionKey)) || 0;
  } catch {}
  audio.volume = 0.45;
  const showState = () => {
    const playing = !audio.paused && !audio.muted;
    button.setAttribute('aria-pressed', String(playing));
    button.querySelector('span').textContent = playing ? button.dataset.on : button.dataset.off;
  };
  const remember = () => {
    try { sessionStorage.setItem(positionKey, String(audio.currentTime)); } catch {}
  };
  const start = () => {
    if (!enabled || pending || document.hidden || competing.size || !audio.paused) return;
    pending = true;
    audio.play().catch(() => {}).finally(() => {
      pending = false;
      if (!enabled || document.hidden || competing.size) audio.pause();
      showState();
    });
  };
  audio.addEventListener('loadedmetadata', () => {
    if (Number.isFinite(audio.duration) && audio.duration > 0) audio.currentTime = savedPosition % audio.duration;
    start();
  }, { once: true });
  audio.addEventListener('timeupdate', () => {
    if (Date.now() - lastSaved > 2000) { remember(); lastSaved = Date.now(); }
  });
  audio.addEventListener('play', showState);
  audio.addEventListener('pause', () => { remember(); showState(); });
  audio.addEventListener('error', showState);
  button.addEventListener('click', event => {
    event.stopPropagation();
    enabled = audio.paused;
    try { localStorage.setItem('db-music-enabled', enabled ? 'on' : 'off'); } catch {}
    if (enabled) {
      for (const media of competing) media.pause();
      competing.clear();
      start();
    } else audio.pause();
    showState();
  });
  const interact = event => {
    if (!host.contains(event.target)) start();
  };
  document.addEventListener('click', interact);
  document.addEventListener('keydown', interact);
  document.addEventListener('play', event => {
    const media = event.target;
    if (media === audio || !(media instanceof HTMLMediaElement) || media.muted || media.volume === 0) return;
    competing.add(media);
    audio.pause();
  }, true);
  const resume = event => { if (competing.delete(event.target)) start(); };
  document.addEventListener('pause', resume, true);
  document.addEventListener('ended', resume, true);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { remember(); audio.pause(); } else start();
  });
  window.addEventListener('pagehide', remember);
  window.addEventListener('pageshow', start);
  showState();
  start();
})();
  } catch(e) { console.error(e); }
})();

})();
